import formatAbsoluteUrl, { JOIN } from '@utils/formatters/absolute-url';
import {
  TradeSignUpBannerWrapperRedesign,
  TradeSignUpTextIconWrapperRedesign,
} from './styles';
import { IconFancyCheck } from 'lib/design-system';
import { Button } from '@checkatrade/web-ui';

const joinNowUrl = formatAbsoluteUrl('/overview', JOIN);

function startsWithVowel(category: string): boolean {
  const vowels = 'aeiouAEIOU';
  return vowels.indexOf(category[0]) !== -1;
}

const TradeSignUpBanner = ({
  category,
  location,
}: {
  category: string;
  location: string;
}) => {
  const aOrAn = startsWithVowel(category) ? 'an' : 'a';
  return (
    <TradeSignUpBannerWrapperRedesign>
      <TradeSignUpTextIconWrapperRedesign>
        <IconFancyCheck size="medium" />
        Do you own {aOrAn} {category} business in {location}?
      </TradeSignUpTextIconWrapperRedesign>
      <Button variant="primary" href={joinNowUrl} data-guid="TopNavTradeSignUp">
        Join Checkatrade today
      </Button>
    </TradeSignUpBannerWrapperRedesign>
  );
};

export default TradeSignUpBanner;
